<template>
  <div >
    <b-container>
      <b-row no-gutters align-h="center">
        <b-col v-for="(shotResult, id) in shotResults" v-bind:key="id" cols="3" >
          <b-button class="selector-button"  squared size="lg" @click="selected(shotResult)">{{shotResult}}</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {shotResults} from '../models/StandardData'
export default {
  name: 'ShotResultSelector',
  props: {
    msg: String
  },
  data () {
    return {
      shotResults: shotResults
    }
  },
  methods: {
    selected(shotResult) {
      this.$emit("shotResultSelected", shotResult)
    }
    /*
    createClubGroups (cols) {
      this.clubGroups = []
      for (var i = 0; i < cols.length; i++) {
        var group = []
        group.push(clubs[i])
      }
    }
    */
  },
  mounted () {
    //createClubGroups()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
